/* ============================================================
   Bernamo — open desktop dropdowns on hover (companion to
   custom-desktop-menu.css)

   Desktop + real mouse only (min-width 990px and hover-capable);
   touch keeps the normal tap behaviour. A small close delay stops
   the menu from snapping shut when the cursor travels from the
   menu item into the panel.
   ============================================================ */
(function () {
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover)');
  var CLOSE_DELAY = 150;

  function summaryOf(details) {
    return details.querySelector('summary');
  }

  function closeMenu(details) {
    if (details.open) details.open = false;
    var s = summaryOf(details);
    if (s) s.setAttribute('aria-expanded', 'false');
  }

  document
    .querySelectorAll('.header__inline-menu header-menu > details')
    .forEach(function (details) {
      var timer = null;
      var host = details.closest('li') || details;

      host.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        // sluit eventuele andere open dropdowns
        document
          .querySelectorAll('.header__inline-menu header-menu > details[open]')
          .forEach(function (other) {
            if (other !== details) closeMenu(other);
          });
        if (!details.open) {
          details.open = true;
          var s = summaryOf(details);
          if (s) s.setAttribute('aria-expanded', 'true');
        }
      });

      host.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          closeMenu(details);
        }, CLOSE_DELAY);
      });
    });
})();
